import intl from "react-intl-universal";
import { DATA_FORMAT_TYPES, getDataFormat } from "utils/format-date";
import { DescriptionText, HighlightBox, SectionContent } from "../../styled";

export interface PickupDateDefinitionProps {
  dateOfTheNeed?: string;
  originalSuggestedPickupDate?: string;
  supplierLeadtime?: string;
  appliedAnticipationDaysOrHours?: string;
  Description?: string;
}

const PickupDateDefinition = (props: PickupDateDefinitionProps) => {
  const {
    dateOfTheNeed,
    originalSuggestedPickupDate,
    supplierLeadtime,
    appliedAnticipationDaysOrHours,
    Description,
  } = props;

  return (
    <SectionContent>
      <DescriptionText $fontSize="0.75rem" $fontWeight={700}>
        {intl.get("stocks.suggestionContext.pickupDateDefinition.title")}
      </DescriptionText>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.pickupDateDefinition.needLabel")}
        </DescriptionText>
        <DescriptionText>{getDataFormat(dateOfTheNeed, DATA_FORMAT_TYPES.WITH_YEAR)}</DescriptionText>
      </div>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.pickupDateDefinition.slaLabel")}
        </DescriptionText>
        <DescriptionText>{`${supplierLeadtime} ${intl.get("stocks.suggestionContext.daysUnit")}`}</DescriptionText>
      </div>

      <div>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.pickupDateDefinition.anticipationLabel")}
        </DescriptionText>
        <DescriptionText>{`D-${appliedAnticipationDaysOrHours}`}</DescriptionText>
      </div>

      <HighlightBox>
        <DescriptionText $fontWeight={700}>
          {intl.get("stocks.suggestionContext.pickupDateDefinition.expectedPickupLabel")}
        </DescriptionText>

        <DescriptionText>
          {getDataFormat(originalSuggestedPickupDate, DATA_FORMAT_TYPES.WITH_YEAR)}
        </DescriptionText>
      </HighlightBox>

      <DescriptionText>{Description}</DescriptionText>
    </SectionContent>
  );
};

export default PickupDateDefinition;
